import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
const DriverAppPrivacyPolicy = () => {
    const title = 'AuspDelivery Driver App Privacty Policy';
    const summary = `At AuspDelivery ("we," "our," or "us"), we value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and protect information through our mobile app ("App") used by drivers to sign up, log in, navigate routes, and deliver packages.`;
    return (
    <div>
      <Header />
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 border-b border-gray-200">
        <div class="py-4 flex flex-col gap-4">
            <div class="text-2xl font-bold">{title}</div>
            <div>
                <div class="text-sm font-bold">Last Updated: April 21, 2025</div>
                <div class='text-sm'>{summary}</div>
            </div>
            <div>
                <div class="text-md font-bold">1. Information We Collect</div>
                <div  class="text-sm">
                    <div class='font-bold'>a. Personal information</div>
                    <div>When you register as a driver, we collect:</div>
                    <div class='pl-4'>1: Full name</div>
                    <div class='pl-4'>2: Email address or phone number</div>
                    <div class='pl-4'>3: Password or authentication credentials</div>
                    <div class='font-bold'>b. Verification Documents</div>
                    <div>Before you're approved to deliver, we require you to upload:</div>
                    <div class='pl-4'>1: A photo of your driver’s license</div>
                    <div class='pl-4'>2: A photo of your vehicle insurance card</div>
                    <div class='pl-4'>3: A photo of your vehicle registration card</div>
                    <div class="text-md font-bold">c. Vehicle Information</div>
                    <div>To qualify for delivery assignments, you must also provide:</div>
                    <div class='pl-4'>1: Vehicle brand (e.g., Toyota)</div>
                    <div class='pl-4'>2: Model (e.g., Corolla)</div>
                    <div class='pl-4'>3: Year of manufacture</div>
                    <div class='font-bold'>d. Location Data</div>
                    <div class='pl-4'>We collect your real-time GPS location during active delivery periods when you are using our mobile app for navigation and delivery updates.</div>
                </div>
            </div>
            <div>
                <div class="text-md font-bold">2. How We Use Your Information</div>
                <div  class="text-sm">
                    <div>We use your data to::</div>
                    <div class='pl-4'>1: Register and verify your identity as a driver</div>
                    <div class='pl-4'>2: Authenticate your registration using email or SMS verification</div>
                    <div class='pl-4'>3: Send you notifications regarding your assigned delivery routes via SMS or email</div>
                    <div class='pl-4'>4: Comply with transportation and safety regulations</div>
                    <div class='pl-4'>5: Monitor delivery progress and ensure performance</div>
                    <div class='pl-4'>6: Improve our logistics and service operations</div>
                </div>
            </div>
            <div>
                <div class="text-md font-bold">3. SMS Consent</div>
                <div  class="text-sm">
                    <div>By signing up to be a driver, you explicitly agree to receive SMS messages from us at the phone number you provide. These messages may include:</div>
                    <div class='pl-4'>1: Verification codes for account registration</div>
                    <div class='pl-4'>2: Notifications when a delivery route is assigned to you</div>
                    <div>Message frequency may vary. Standard messaging and data rates may apply. You may not opt out of these essential service-related messages while you remain an active driver.</div>
                </div>
            </div>
            <div>
                <div class="text-md font-bold">4. When We Share Your Information</div>
                <div  class="text-sm">
                    <div>We may share your data with:</div>
                    <div class='pl-4'>1: Internal operations and support staff</div>
                    <div class='pl-4'>2: Partners or clients as needed for delivery coordination (e.g., recipients may see your name or route info)</div>
                    <div class='pl-4'>3: Legal or regulatory authorities when required by law</div>
                    <div>We do not sell your personal information to third parties.</div>
                </div>
            </div>
            <div>
                <div class="text-md font-bold">5. Data Retention</div>
                <div  class="text-sm">
                    <div>We retain your personal data only for as long as necessary to provide our services or comply with legal obligations. You can request deletion of your personal data from the app or by contacting us at aupsdelivery@gamil.com</div>
                </div>
            </div>
            <div>
                <div class="text-md font-bold">6. Your Rights</div>
                <div  class="text-sm">
                    <div>You have the right to:</div>
                    <div class='pl-4'>1: Access, update and delete your personal information.</div>
                    <div class='pl-4'>2: Request the deletion of your account and data (subject to legal obligations).</div>
                    <div class='pl-4'>3: Object to or restrict certain data processing activities.</div>
                </div>
            </div>
            <div>
                <div class="text-md font-bold">7. Data Security</div>
                <div  class="text-sm">
                    <div>We implement industry-standard security measures to protect your data. However, no method of transmission over the internet or method of storage is 100% secure. We encourage you to keep your login credentials safe.</div>
                </div>
            </div>
            <div>
                <div class="text-md font-bold">8. Changes to This Privacy Policy</div>
                <div  class="text-sm">
                    <div>We may update this Privacy Policy from time to time. When we make changes, we will notify you through the App or other means. Your continued use of the App indicates your acceptance of the updated policy.</div>
                </div>
            </div>
            <div>
                <div class="text-md font-bold">9. Contact Us</div>
                <div  class="text-sm">
                    <div>If you have any questions or concerns about this Privacy Policy, please contact us at:</div>
                    <div class="font-bold">AuspDelivery LLC</div>
                    <div>Email: aupsdelivery@gmail.com</div>
                </div>
            </div>
        </div>
      </div>
      <Footer />
    </div>  )
}

export default DriverAppPrivacyPolicy